export default function selectAll({ formik, trackers }) {
  formik.setFieldValue(
    'cars',
    trackers.map(({ id }) => id)
  );
}
